module.exports = __webpack_public_path__ + "img/flappy-bird-full-website-1.3f2e0d54.png";